import React, { useRef, useState } from 'react';
import GoogleMapReact from "google-map-react";
import DashboardIncidentMarker from './DashboardIncidentMarker';

function DashboardMap({ lat = 24.491241, lng = 54.37831961, details = "", announcements = [], height = "520px" }) {

  const mapRef = useRef(null);
  const mapsRef = useRef(null);

  const [defaultProps] = useState({
    center: {
      lat: 24.491241,
      lng: 54.37831961,
    },
    zoom: 13,
    minZoom: 10 // Set a minimum zoom level
  });

  const handleApiLoaded = (map, maps) => {
    // Create a new LatLngBounds object
    const bounds = new maps.LatLngBounds();

    // Extend the bounds with each marker's position
    announcements.forEach((announcement) => {
      bounds.extend(new maps.LatLng(announcement.lat, announcement.lng));
    });

    // Fit the map to the bounds
    map.fitBounds(bounds);

    const listener = maps.event.addListener(map, 'idle', () => {
      if (map.getZoom() > defaultProps.minZoom) {
        map.setZoom(defaultProps.minZoom);
      }
      maps.event.removeListener(listener);
    });
  };

  return (
    <div className="bg-white rounded-xl border border-neutral-200 shadow-subtle overflow-hidden relative h-full">
      <div className="relative bg-[#eef3f7]" style={{ height, minHeight: '520px' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyCI8O91FfQgfevadyNo9pKNt52MT5RZp_4" }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => {
            mapRef.current = map;
            mapsRef.current = maps;
            handleApiLoaded(map, maps);
          }}
        >
          {announcements.map((announcement) => (
            <DashboardIncidentMarker
              key={announcement.id}
              lat={announcement.lat}
              lng={announcement.lng}
              announcement={announcement}
            />
          ))}
        </GoogleMapReact>

        {announcements.length === 0 && (
          <div className="absolute inset-0 flex items-center justify-center text-sm font-medium text-neutral-400">
            No incident locations to display
          </div>
        )}
      </div>
    </div>
  )
}

export default DashboardMap
